import { Component, OnInit } from '@angular/core';
import { Compbaser } from "../compbaser";
import { actionUpdateSceneItem } from "../../store/actions/user.actions";
import { Id, IAnchorProps, ISceneBlock, ISceneTreeSliceResults } from "../../interfaces";
import { StoreSelectorsService } from "../../services";
import { isNullOrUndef } from '../../common';
import * as _ from 'lodash';
@Component({
    selector: 'app-anchor',
    templateUrl: './anchor.component.html',
    styleUrls: ['./anchor.component.scss'],
    standalone: false
})
export class AnchorComponent extends Compbaser implements OnInit {
    private sceneId: Id;
    private sceneItem: ISceneBlock;

    readonly model: IAnchorProps = {
        left: null,
        right: null,
        top: null,
        bottom: null,
        verticalCenter: null,
        horizontalCenter: null
    };

    constructor(private storeSelector: StoreSelectorsService) {
        super();
    }

    ngOnInit() {
        this.cod(
            this.storeSelector.listenPlayerDataOfSelectedSceneItemId()
                .subscribe((i_sceneSlice: ISceneTreeSliceResults) => {
                    this.sceneId = i_sceneSlice.sceneId;
                    this.sceneItem = i_sceneSlice.sceneItem;
                    const anchorLayout = i_sceneSlice.sceneItem?.AnchorLayoutData;

                    Object.keys(this.model).forEach((k) => {
                        if (k.includes("Checked")) return;
                        this.model[k] = anchorLayout && anchorLayout[0]?.$[k] && anchorLayout[0].$[k] !== 'NaN' ? anchorLayout[0].$[k] : null;
                        this.model[`${k}Checked`] = !isNullOrUndef(this.model[k]);
                    });
                })
        );
    }

    onChange(i_from) {
        const defValue = '0';
        const nanValue = 'NaN';
        const newModel = _.cloneDeep(this.model);

        switch (i_from) {
            case 'left': {
                newModel.left = newModel.leftChecked ? (newModel.left || defValue) : null;
                newModel.horizontalCenter = null;
                break;
            }
            case 'right': {
                newModel.right = newModel.rightChecked ? (newModel.right || defValue) : null;
                newModel.horizontalCenter = null;
                break;
            }
            case 'top': {
                newModel.top = newModel.topChecked ? (newModel.top || defValue) : null;
                newModel.verticalCenter = null;
                break;
            }
            case 'bottom': {
                newModel.bottom = newModel.bottomChecked ? (newModel.bottom || defValue) : null;
                newModel.verticalCenter = null;
                break;
            }
            case 'horizontalCenter': {
                newModel.horizontalCenter = newModel.horizontalCenterChecked ? (newModel.horizontalCenter || defValue) : null;
                newModel.left = null;
                newModel.right = null;
                break;
            }
            case 'verticalCenter': {
                newModel.verticalCenter = newModel.verticalCenterChecked ? (newModel.verticalCenter || defValue) : null;
                newModel.top = null;
                newModel.bottom = null;
                break;
            }
            default: {
                return;
            }
        }

        delete newModel.leftChecked;
        delete newModel.rightChecked;
        delete newModel.topChecked;
        delete newModel.bottomChecked;
        delete newModel.horizontalCenterChecked;
        delete newModel.verticalCenterChecked;

        Object.keys(newModel).forEach((k) => {
            newModel[k] = newModel[k] == null ? nanValue : `${newModel[k]}`;
        });

        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: '$',
                value: newModel,
                storePath: 'AnchorLayoutData[0]',
                cloneValue: true
            }]
        }));
        this.storeSelector.dispatch({ type: 'BREAK_MERGE' });
    }

    override destroy() {
        super.destroy();
    }
}
